import { DataEntity } from "@barthauer/abc/graphics/adapters/open-layers";

export class NetworkTraceObject {
  Id: string;
  ObjectTypeName: string;
  IsInFlowDirection: boolean;
  GeometryWKT: any;
  SelectionPosition?: string;
  FirstNode: DataEntity;
  SecondNode: DataEntity;
  constructor(data: any) {
    Object.assign(this, data);
  }
}
